import UserAccountsModal from "../components/UserAccountsModal";
import LeftNav1 from "../components/LeftNav1";


const UserAccountsSignInUp = () => {
  const userAccountsData = [
    {
      title: `Sign-up/Sign-in`,
      text: `The user-friendly Sign-in feature in L7 allows 
      multiple users to create new, secure accounts, log 
      in or out of their personal OneScreen accounts as 
      well as access their personalized settings and 
      stored data across multiple OneScreen Touchscreens.`,
      videoURL: `https://www.youtube.com/embed/wqPK5osg024`,
      dots: `dots1.png`,
      height: `364px`,
    },
    {
      title: `Personalization`,
      text: `The personalization tab in OneScreen Account allows users to customize
    their lock screen passwords, display settings, and favorite widgets.
    Watch the video to know more.`,
      videoURL: `https://www.youtube.com/embed/sCY4t4ogiZw`,
      dots: `dots2.png`,
      height: `334px`,
    },
    {
      title: `Management`,
      text: `To manage your Account settings, tap on your Avatar on the top right
      corner and go to “Settings”. You can change your login information,
      location details and other Account information here.`,
      videoURL: `https://www.youtube.com/embed/Uc-cKVPWvH0`,
      dots: `dots3.png`,
      height: `364px`,
    },
    {
      title: `Settings & Security`,
      text: `Change your OneScreen Account password and the lock screen password
      from the “Security” tab on the OneScreen Account window. To learn
      more, watch the video below`,
      videoURL: `https://www.youtube.com/embed/yC0fh5Ubl2s`,
      dots: `dots4.png`,
      height: `364px`,
    },
  ];

  return (
    <div className="h-screen overflow-hidden">
      <div className="flex p-1 mx-auto overflow-hidden justify-center w-[1300px] h-[620px] text-center text-xs text-darkslategray font-open-sans">
        <div className="bg-gray-200 mr-1">
          <LeftNav1 />
        </div>
        <div className="w-[1073px] bg-white mr-5 bg-tl-screen bg-center bg-cover h-[605px]">
          <div className="relative top-0 left-0 max-w-full h-full bg-gray backdrop-brightness-20">
            <div className="relative w-[50px] h-[15px] left-[1005px] top-[12px] rounded-sm font-roboto bg-lime-500">
              <div className="text-[8px] text-white">
                Sign In
              </div>
            </div>
            <UserAccountsModal data={userAccountsData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserAccountsSignInUp;
